import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/autoprefixer': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M318.4 16L157.4 496H234.9L260.3 414.6H379.8L405 496H482.5L318.4 16zM278.1 357.9L319.3 227.5H320.8L361.7 357.9H278.1zM640 405L630 373.6 462.1 358 481.5 414.5 640 405zM177.9 358L10 373.7 0 405 158.5 414.4 177.9 358z'
      }
    ]
  }
})
